<ng-container *ngIf="loading; else content">
  <app-loading-section></app-loading-section>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
